/**
 * @generated SignedSource<<55c00549ef6ee880964a9f240e06ce9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectPersonList_user$data = {
  readonly favourite_people: any;
  readonly id: number;
  readonly " $fragmentType": "SelectPersonList_user";
};
export type SelectPersonList_user$key = {
  readonly " $data"?: SelectPersonList_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectPersonList_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectPersonList_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favourite_people",
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "d46896ea4d00179622fe0d19a5697d03";

export default node;
